function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StepHeader from '../../step-header';
import StepWrapper from '../step-wrapper';
import store from '../../../stores/main';
import TonePlayer from './tone-player';
import ToneFeedback from './tone-feedback';
import globals from '../../../utils/globals';
import CircularProgress from './circular-progress-bar';
var START_DB_INDEX = 3;
var TONES_DATA = [{
  value: '500 Hz',
  sounds: [{
    label: '10dB',
    points: 1
  }, {
    label: '20dB',
    points: 2
  }, {
    label: '30dB',
    points: 3
  }, {
    label: '40dB',
    points: 4
  }, {
    label: '50dB',
    points: 5
  }, {
    label: '60dB',
    points: 6
  }, {
    label: '70dB',
    points: 7
  }]
}, {
  value: '1000 Hz',
  sounds: [{
    label: '10dB',
    points: 1
  }, {
    label: '20dB',
    points: 2
  }, {
    label: '30dB',
    points: 3
  }, {
    label: '40dB',
    points: 4
  }, {
    label: '50dB',
    points: 5
  }, {
    label: '60dB',
    points: 6
  }, {
    label: '70dB',
    points: 7
  }]
}, {
  value: '4000 Hz',
  sounds: [{
    label: '10dB',
    points: 1
  }, {
    label: '20dB',
    points: 2
  }, {
    label: '30dB',
    points: 3
  }, {
    label: '40dB',
    points: 4
  }, {
    label: '50dB',
    points: 5
  }, {
    label: '60dB',
    points: 6
  }, {
    label: '70dB',
    points: 7
  }]
}];

var ToneStep = /*#__PURE__*/function (_Component) {
  _inherits(ToneStep, _Component);

  var _super = _createSuper(ToneStep);

  function ToneStep(props) {
    var _this;

    _classCallCheck(this, ToneStep);

    _this = _super.call(this, props);
    _this.state = {
      currentHzIndex: 0,
      currentDBIndex: 3,
      accumulatedScore: 0,
      hasSignificantHearingLoss: false,
      soundIndex: 1
    };
    _this.currentSoundFile = _this.currentSoundFile.bind(_assertThisInitialized(_this));
    _this.tonePlayerClickHandler = _this.tonePlayerClickHandler.bind(_assertThisInitialized(_this));
    _this.toneDone = _this.toneDone.bind(_assertThisInitialized(_this));
    window.DGS.Event.getInstance().trigger('trackHearingTestNextStep', globals.STEP_TYPE_TONE_START);
    return _this;
  }

  _createClass(ToneStep, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.onToneChange(this.state.currentHzIndex + 1);
    }
  }, {
    key: "currentSoundFile",
    value: function currentSoundFile() {
      var currentHz = TONES_DATA[this.state.currentHzIndex].value.replace(/ /g, '');
      var currentDB = TONES_DATA[this.state.currentHzIndex].sounds[this.state.currentDBIndex].label.replace(/ /g, '');
      var key = "Tone".concat(currentHz).concat(currentDB);
      var soundFile = this.props.soundPaths[key];
      return soundFile;
    }
    /**
     * Handles user feedback on tone test. If tone is audible, play lower sound dB. If not,
     * play higher sound dB.
     * @param {boolean} userDidHear True if user indicated he heard the sound, false if not
     */

  }, {
    key: "tonePlayerClickHandler",
    value: function tonePlayerClickHandler(userDidHear) {
      var _this2 = this;

      var currentDBIndex = this.state.currentDBIndex;
      var numSounds = TONES_DATA[this.state.currentHzIndex].sounds.length;
      var nextDBIndex = userDidHear ? this.state.currentDBIndex - 1 : this.state.currentDBIndex + 1;
      var isLoudestTone = nextDBIndex === numSounds;
      var toneIsDone = nextDBIndex < 0 || // we've played the quietest dB
      isLoudestTone || userDidHear && currentDBIndex > START_DB_INDEX || !userDidHear && currentDBIndex < START_DB_INDEX; // we've played a quieter dB and the user can't hear the next sound

      if (toneIsDone) {
        // If user heard the quietest tone (index = 0), don't add points
        var userHeardQuietestTone = this.state.currentDBIndex === 0 && userDidHear;

        var _ref = userHeardQuietestTone ? 0 : TONES_DATA[this.state.currentHzIndex].sounds[this.state.currentDBIndex],
            points = _ref.points; // if the user didn't hear the loudest sound, set significant hearing loss:


        if (!userDidHear && isLoudestTone) {
          this.setState({
            hasSignificantHearingLoss: true
          }, function () {
            return _this2.toneDone(points);
          });
        } else {
          this.toneDone(points);
        }
      } else {
        this.setState({
          currentDBIndex: nextDBIndex,
          soundIndex: this.state.soundIndex + 1
        });
      }
    }
    /**
     * Adds score for current tone to state.accumulatedScore and either:
     * 1) plays the next tone if there is one, or
     * 2) calls props.onNextClick with the accumulated score
     */

  }, {
    key: "toneDone",
    value: function toneDone(points) {
      var _this3 = this;

      var accumulatedScore = this.state.accumulatedScore + points;
      var index = this.state.currentHzIndex;

      if (index < TONES_DATA.length - 1) {
        // go to next Hz
        this.setState({
          accumulatedScore: accumulatedScore,
          currentHzIndex: index + 1,
          currentDBIndex: START_DB_INDEX,
          soundIndex: 1
        });
      } else {
        // test is done, call onNextClick with points
        this.setState({
          accumulatedScore: accumulatedScore
        }, function () {
          return _this3.props.onNextClick({
            points: _this3.state.accumulatedScore,
            significantHearingLoss: _this3.state.hasSignificantHearingLoss
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var content = this.props.content;
      var _this$state = this.state,
          currentHzIndex = _this$state.currentHzIndex,
          currentDBIndex = _this$state.currentDBIndex,
          soundIndex = _this$state.soundIndex;
      var soundFile = this.currentSoundFile();
      var heading = content.Heading.replace('{Hz}', TONES_DATA[currentHzIndex].value).replace('{dB}', TONES_DATA[currentHzIndex].sounds[currentDBIndex].label);
      var yesButtonLabel = content.ResponseOptions.find(function (option) {
        return option.TriggerPoints === true;
      }).Label;
      var noButtonLabel = content.ResponseOptions.find(function (option) {
        return option.TriggerPoints === false;
      }).Label;
      var HzTypesAmount = TONES_DATA.length;
      var percentage = Math.floor(currentHzIndex / HzTypesAmount * 100 + (soundIndex - 1) / (HzTypesAmount * (TONES_DATA[currentHzIndex].sounds.length - START_DB_INDEX)) * 100);
      return /*#__PURE__*/React.createElement(StepWrapper, {
        backgroundImage: content.BackgroundImage,
        stepClassNames: "step--tone"
      }, /*#__PURE__*/React.createElement("div", {
        className: "step__text"
      }, /*#__PURE__*/React.createElement(StepHeader, {
        icon: content.StepHeaderIcon,
        header: content.StepHeaderTitle
      }), /*#__PURE__*/React.createElement("div", {
        className: "tone-progress"
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        sqSize: 60,
        strokeWidth: 10,
        percentage: percentage,
        showPercentage: true
      })), /*#__PURE__*/React.createElement("p", {
        className: "step__body"
      }, content.Body), /*#__PURE__*/React.createElement("h1", {
        className: "step__title"
      }, heading), /*#__PURE__*/React.createElement(TonePlayer, {
        soundFile: soundFile,
        volume: store.baseVolume,
        key: soundFile
      })), /*#__PURE__*/React.createElement("div", {
        className: "step__buttons"
      }, /*#__PURE__*/React.createElement(ToneFeedback // soundFile={soundFile}
      , {
        onYesClick: function onYesClick() {
          return _this4.tonePlayerClickHandler(true);
        },
        onNoClick: function onNoClick() {
          return _this4.tonePlayerClickHandler(false);
        },
        yesButtonLabel: yesButtonLabel,
        noButtonLabel: noButtonLabel // volume={store.baseVolume}

      })));
    }
  }]);

  return ToneStep;
}(Component);

ToneStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onToneChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  soundPaths: PropTypes.object.isRequired
};
export default ToneStep;